'use client';

import { useState, useTransition } from 'react';
import Image from 'next/image';
import { signIn } from './actions';

export function LoginForm({ bannerError }: { bannerError?: string | null }) {
  const [error, setError]            = useState('');
  const [isPending, startTransition] = useTransition();

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError('');
    const formData = new FormData(e.currentTarget);
    startTransition(async () => {
      const result = await signIn(formData);
      if ('error' in result) {
        setError(result.error);
      } else {
        window.location.href = '/';
      }
    });
  }

  return (
    <div className="w-full max-w-sm">
      <div className="bg-cream-card border border-rule rounded-sm px-8 py-9 shadow-[0_4px_24px_rgba(14,20,32,0.08)]">
        <div className="flex items-center gap-2.5 mb-8">
          <Image src="/logo.png" alt="" width={32} height={32} className="h-8 w-8 shrink-0" />
          <div>
            <div className="font-sans font-bold text-[20px] text-navy leading-none">IntegrePro</div>
            <div className="text-[9px] uppercase tracking-[0.2em] text-ink-muted mt-1">Lighthouse</div>
          </div>
        </div>
        {bannerError && (
          <p className="text-[12px] text-prio-red mb-4">{bannerError}</p>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-ink-muted mb-1.5" htmlFor="email">
              Email
            </label>
            <input
              id="email" name="email" type="email" required autoComplete="email"
              className="w-full px-3 py-2 text-[13px] border border-rule rounded-sm bg-white focus:outline-none focus:border-navy"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-ink-muted mb-1.5" htmlFor="password">
              Password
            </label>
            <input
              id="password" name="password" type="password" required autoComplete="current-password"
              className="w-full px-3 py-2 text-[13px] border border-rule rounded-sm bg-white focus:outline-none focus:border-navy"
            />
          </div>
          {error && <p className="text-[12px] text-prio-red">{error}</p>}
          <button
            type="submit" disabled={isPending}
            className="w-full py-2.5 text-[13px] font-medium text-white bg-brand-gradient rounded-sm hover:opacity-90 transition-opacity disabled:opacity-60"
          >
            {isPending ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div className="mt-5 text-center">
          <a href="/auth/forgot-password" className="text-[11px] text-ink-muted hover:text-navy transition-colors">
            Forgot password?
          </a>
        </div>
      </div>
    </div>
  );
}
